import { useEffect, useState } from "react";
import { VulnerabilityInstanceData, getVulnerabilityInstance } from "../remote/scan_data"
import { Button, CircularProgress, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export interface VulnerabilityInstanceProps {
	id: string
	data?: VulnerabilityInstanceData | undefined
	hideChildren?: boolean
}

export const VulnerabilityInstanceSimple = ({id, data=undefined}: VulnerabilityInstanceProps) => {
	const navigate = useNavigate()

	const [vulnerabilityData, setVulnerabilityInstanceData] = useState<VulnerabilityInstanceData | null | undefined>(data);
	useEffect(() => {
		if (data == undefined) {
			getVulnerabilityInstance(id, (data, resp) => {
				if (data) {
					setVulnerabilityInstanceData(data);
				} else {
					setVulnerabilityInstanceData(null);
				}
			});
		}
	}, [setVulnerabilityInstanceData]);

	return (vulnerabilityData
		? <Button onClick={() => navigate(`/tree/vulnerability/${id}`)}>
			<Stack direction={'column'}>
			<Typography sx={{wordBreak: 'break-all'}}>
			{vulnerabilityData.vulnerability?.cve_id ?? "Missing CVE"} - {vulnerabilityData.vulnerability?.severity} - CVSS: {vulnerabilityData.vulnerability?.cvss_score ?? "Missing"}
			</Typography> <br />
			<Typography sx={{wordBreak: 'break-all', textTransform: 'none'}}>
			{vulnerabilityData.location} {vulnerabilityData.location.length > 0 ? <br /> : <></>}
			{vulnerabilityData.remediation}
			</Typography>
			</Stack>
		</Button>
		: <CircularProgress />
	)
}

export const VulnerabilityInstance = ({id, data=undefined, hideChildren=false}: VulnerabilityInstanceProps) => {
	const navigate = useNavigate()

	const [vulnerabilityData, setVulnerabilityInstanceData] = useState<VulnerabilityInstanceData | null | undefined>(data);
	useEffect(() => {
		if (data == undefined) {
			getVulnerabilityInstance(id, (data, resp) => {
				if (data) {
					setVulnerabilityInstanceData(data);
				} else {
					setVulnerabilityInstanceData(null);
				}
			});
		}
	}, [setVulnerabilityInstanceData]);

	return (vulnerabilityData
		?
		<TableContainer component={Paper}>
			<Table width={hideChildren ? 'auto' : '100%'}>
				<TableHead>
					<TableRow>
						<TableCell>
							<Typography variant="h5">Vulnerability</Typography>
						</TableCell>
						<TableCell align='right'>
							{hideChildren ? (<></>) :
							(vulnerabilityData.children.length > 0 ?
							<Button onClick={() => navigate(`/tree/ip/${id}`)}>See children</Button>
							: <Button disabled>No children</Button>)}
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{vulnerabilityData.vulnerability
						? <>
							<TableRow><TableCell align='left'>CVE</TableCell><TableCell align='right'>{vulnerabilityData.vulnerability.cve_id}</TableCell></TableRow>
							<TableRow><TableCell align='left'>Severity</TableCell><TableCell align='right'>{vulnerabilityData.vulnerability.severity}</TableCell></TableRow>
							<TableRow><TableCell align='left'>Description</TableCell><TableCell align='right'>{vulnerabilityData.vulnerability.description}</TableCell></TableRow>
							<TableRow><TableCell align='left'>CVSS Score</TableCell><TableCell align='right'>{vulnerabilityData.vulnerability.cvss_score}</TableCell></TableRow>
							<TableRow><TableCell align='left'>CVSS Metrics</TableCell><TableCell align='right'>{vulnerabilityData.vulnerability.cvss_metrics}</TableCell></TableRow>
						</>
						: <></>
					}
					<TableRow><TableCell align='left'>Location</TableCell><TableCell align='right'>{String(vulnerabilityData.location)}</TableCell></TableRow>
					<TableRow><TableCell align='left'>Remediation</TableCell><TableCell align='right'>{String(vulnerabilityData.remediation)}</TableCell></TableRow>
					<TableRow><TableCell align='left'>First seen</TableCell><TableCell align='right'>{String(vulnerabilityData.first_seen)}</TableCell></TableRow>
					<TableRow><TableCell align='left'>Last seen</TableCell><TableCell align='right'>{String(vulnerabilityData.last_seen)}</TableCell></TableRow>
				</TableBody>
			</Table>
			</TableContainer>
		: <CircularProgress />
	)
}
